import React, { useContext } from "react";
import { NavLink } from "react-router-dom";

import {
  NavBar,
  NavBarItem,
  NavBarSection,
} from "@transfr-inc/dashboard-components";
import { useRouteMatch } from "react-router-dom";
import { ProfileNavBarItem } from ".";
import {
  IntegrationsRoute,
  LibraryRoute,
  OrganizationsRoute,
  RootPath,
  SearchRoute,
  TemplatesRoute,
  UsersRoute,
} from "./routes";

import {
  OrganizationContext,
  SessionContext,
  UsersContext,
} from "../../context";
import { toggles } from "../../dependencies";

const { isLibraryEnabled } = toggles;

import "./navbar.scss";

export default ({ isExpanded, onSkipNavigation }) => {
  const { url } = useRouteMatch(RootPath);
  const { currentUser, role } = useContext(SessionContext);
  const { usersCount } = useContext(UsersContext);
  const { orgsCount } = useContext(OrganizationContext);

  const organizationsNavItem = (
    <NavBarItem
      to={`${url}${OrganizationsRoute.path}`}
      isExpanded={isExpanded}
      icon={OrganizationsRoute.icon}
      label={OrganizationsRoute.label}
      labelAbbr={OrganizationsRoute.labelAbbr}
      badge={orgsCount}
      routerComponent={NavLink}
    />
  );

  const usersNavItem = (
    <NavBarItem
      to={`${url}${UsersRoute.path}`}
      isExpanded={isExpanded}
      icon={UsersRoute.icon}
      label={UsersRoute.label}
      labelAbbr={UsersRoute.labelAbbr}
      badge={usersCount}
      routerComponent={NavLink}
    />
  );

  const integrationsNavItem = (
    <NavBarItem
      to={`${url}${IntegrationsRoute.path}`}
      isExpanded={isExpanded}
      icon={IntegrationsRoute.icon}
      label={IntegrationsRoute.label}
      labelAbbr={IntegrationsRoute.labelAbbr}
      routerComponent={NavLink}
    />
  );

  const searchNavItem = (
    <NavBarItem
      to={`${url}${SearchRoute.path}`}
      isExpanded={isExpanded}
      icon={SearchRoute.icon}
      label={SearchRoute.label}
      labelAbbr={SearchRoute.labelAbbr}
      routerComponent={NavLink}
    />
  );

  const templatesNavItem = (
    <NavBarItem
      to={`${url}${TemplatesRoute.path}`}
      isExpanded={isExpanded}
      icon={TemplatesRoute.icon}
      label={TemplatesRoute.label}
      labelAbbr={TemplatesRoute.labelAbbr}
      routerComponent={NavLink}
    />
  );

  const libraryNavItem = (
    <NavBarItem
      to={`${url}${LibraryRoute.path}`}
      isExpanded={isExpanded}
      icon={LibraryRoute.icon}
      label={LibraryRoute.label}
      labelAbbr={LibraryRoute.labelAbbr}
      routerComponent={NavLink}
    />
  );

  return (
    <NavBar
      className="client-portal-navbar"
      onSkipNavigation={onSkipNavigation}
      subtitle="Internal Portal"
    >
      <NavBarSection>
        {organizationsNavItem}
        {usersNavItem}
        {integrationsNavItem}
        {searchNavItem}
        {templatesNavItem}
        {isLibraryEnabled && libraryNavItem}
      </NavBarSection>
      <NavBarSection className="bottom-section">
        <ProfileNavBarItem user={currentUser} role={role}></ProfileNavBarItem>
      </NavBarSection>
    </NavBar>
  );
};
